import { createViewColumn } from './create'
import { deleteViewColumn } from './delete'
import { readViewColumns } from './read'
import { updateViewColumn } from './update'

export const viewColumns = {
  readCollection: readViewColumns,
  create: createViewColumn,
  update: updateViewColumn,
  delete: deleteViewColumn,
}
